import React, { useContext, useEffect, useState } from 'react'
import moment from 'moment'

import DateRange from '../DateRange'
import { DateControlContext } from 'contexts/DateControlContext'
import { CustomDateTab } from './CustomDateTab'

import * as S from './StandardDateControl.styles'
import { DATE_PICKER_FREQUENCIES } from './DateControl'

type Props = {
  customDateVariant?: 'below' | 'inlineTab'
}

export const StandardDateControl: React.FC<Props> = ({ customDateVariant = 'below' }) => {
  const { startDate, endDate, frequency, onChange } = useContext(DateControlContext)
  const [hasCustomApplied, setHasCustomApplied] = useState(false)

  useEffect(() => {
    if (frequency !== DATE_PICKER_FREQUENCIES.custom) {
      setHasCustomApplied(false)
    }
  }, [frequency])

  const handleChange = frequency => {
    let newStartDate, newEndDate
    switch (frequency) {
      case DATE_PICKER_FREQUENCIES.week: {
        newStartDate = moment().subtract(1, 'week').add(1, 'day')
        newEndDate = moment()
        break
      }
      case DATE_PICKER_FREQUENCIES.month: {
        newStartDate = moment().subtract(1, 'month').add(1, 'day')
        newEndDate = moment()
        break
      }
      case DATE_PICKER_FREQUENCIES.custom: {
        newStartDate = startDate
        newEndDate = endDate
        break
      }
    }

    onChange({ startDate: newStartDate, endDate: newEndDate, frequency })
  }

  const handleCustomDate = (nextStartDate, nextEndDate) => {
    onChange({ startDate: nextStartDate, endDate: nextEndDate, frequency: DATE_PICKER_FREQUENCIES.custom })
    setHasCustomApplied(true)
  }

  const isCustom = frequency === DATE_PICKER_FREQUENCIES.custom
  const useInlineCustomTab = customDateVariant === 'inlineTab'

  return (
    <S.DateControl>
      <S.Frequency>
        <S.FrequencyButtons>
          <S.FrequencyButton
            onClick={() => handleChange(DATE_PICKER_FREQUENCIES.week)}
            isSelected={frequency === DATE_PICKER_FREQUENCIES.week}>
            Last 7 days
          </S.FrequencyButton>
          <S.FrequencyButton
            onClick={() => handleChange(DATE_PICKER_FREQUENCIES.month)}
            isSelected={frequency === DATE_PICKER_FREQUENCIES.month}>
            Last 30 days
          </S.FrequencyButton>
          {useInlineCustomTab ? (
            <CustomDateTab
              isSelected={hasCustomApplied}
              startDate={startDate}
              endDate={endDate}
              onApply={handleCustomDate}
            />
          ) : (
            <S.FrequencyButton
              onClick={() => handleChange(DATE_PICKER_FREQUENCIES.custom)}
              isSelected={isCustom}>
              Custom
            </S.FrequencyButton>
          )}
        </S.FrequencyButtons>
      </S.Frequency>

      {!useInlineCustomTab && isCustom && (
        <S.CustomDateRangeWrap>
          <DateRange startDate={startDate} endDate={endDate} setDate={handleCustomDate} />
        </S.CustomDateRangeWrap>
      )}
    </S.DateControl>
  )
}
